import { participationStatusBadges } from '../../../../backend/extraTypes';
export function getParticipationStatusBadgeLabel(t, participationStatus) {
    if (participationStatus && !participationStatusBadges.includes(participationStatus)) {
        return undefined;
    }
    return participationStatus
        ? t(`missions.participationStatusBadgeLabels.${participationStatus}`)
        : undefined;
}
